import React, { useState, useEffect } from 'react';
import Modal from '../Modal';
import Input from '../Input';
import Editor from './Editor';

const RuleModal = ({ setVisible, rules, setRules, index }) => {
  let [editedRule, setEditedRule] = useState(() => ({...rules[index]}));
  let [selectedCondition, setSelectedCondition] = useState('');
  let [values, setValues] = useState([]);

  useEffect(() => {
    try {
      const obj = JSON.parse(editedRule.when);
      const key = Object.keys(obj)[0];
      setSelectedCondition(key);

      if (['utm_source_in', 'utm_campaign_in', 'utm_term_in', 'ip_in'].includes(key)) {
        setValues(obj[key]);
      }
    }
    catch (e) {
      setSelectedCondition('');
      setValues([]);
    }
  }, [editedRule.when]);

  const getWhen = (condition, values) => {
    if (['utm_source_in', 'utm_campaign_in', 'utm_term_in', 'ip_in'].includes(condition)) {
      return {when: JSON.stringify({
        [condition]: values || [],
      })};
    }
    else {
      return {when: ''};
    }
  }

  return (
    <Modal isOpen={true}
           zIndex={400}>
      <div style={{
             background: 'linear-gradient(gray, transparent)',
             position: 'absolute',
             transform: 'translate(-50%, -50%)',
             top: '50%',
             left: '50%',
             width: '800px',
             borderRadius: '10px',
           }}>
        <div
          style={{
            margin: '1px',
            borderRadius: '10px',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            padding: '20px',
            backgroundColor: 'black',
            gap: '20px',
          }}>
          <span style={{fontSize: '22px',
                        fontWeight: 'bold',
                       }}>
            Rule
          </span>

          <Input
            label="NAME"
            value={editedRule.name}
            onChange={(e) =>
              setEditedRule(prev => ({ ...prev, name: e.target.value }))
            }/>

          <div style={{display: 'flex',
                       flexDirection: 'row',
                       alignItems: 'center',
                       gap: '20px',
                      }}>
            <span style={{fontSize: '22px',
                          fontWeight: 'bold',
                         }}>
              Action
            </span>

            <select style={{padding: '10px',
                            borderRadius: '5px',
                            border: '1px solid #e0e0e0',
                            fontSize: '16px',
                            width: '50%',
                           }}
                    value={editedRule.action}
                    onChange={(e) => {
                      const action = e.target.value;
                      setEditedRule(prev => ({ ...prev, action }));
                    }}>
              <option value="captcha">
                captcha
              </option>
              <option value="audit">
                audit
              </option>
              <option value="skip">
                skip
              </option>
            </select>
          </div>

          <div style={{display: 'flex',
                       flexDirection: 'row',
                       alignItems: 'center',
                       gap: '20px',
                      }}>

            <span style={{fontSize: '22px',
                          fontWeight: 'bold',
                         }}>
              When
            </span>

            <select style={{padding: '10px',
                            borderRadius: '5px',
                            border: '1px solid #e0e0e0',
                            fontSize: '16px',
                            width: '50%',
                           }}
                    value={selectedCondition}
                    onChange={(e) => {
                      const condition = e.target.value;
                      setSelectedCondition(condition);
                    }}>
              <option value=""></option>
              <option value="utm_source_in">
                utm_source_in
              </option>
              <option value="utm_campaign_in">
                utm_campaign_in
              </option>
              <option value="utm_term_in">
                utm_term_in
              </option>
              <option value="ip_in">
                ip_in
              </option>
            </select>
          </div>

          {['utm_source_in', 'utm_campaign_in', 'utm_term_in', 'ip_in'].includes(selectedCondition) && (
            <Editor
              values={values}
              onChange={setValues}
            />
          )}

          <div style={{display: 'flex',
                       flexDirection: 'row',
                       alignItems: 'center',
                       marginTop: '10px',
                       gap: '10px',
                       justifyContent: 'center',
                      }}>
            <div style={{alignItems: 'center',
                         padding: '10px 20px',
                         border: '1px solid #e0e0e0',
                         borderRadius: '5px',
                         cursor: 'pointer',
                         fontWeight: 'bold',
                         alignSelf: 'flex-end',
                         display: 'flex',
                         justifyContent: 'center',
                        }}
                 onClick={() => setVisible(false)}>
              Cancel
            </div>
            <div style={{alignItems: 'center',
                         padding: '10px 20px',
                         backgroundColor: '#009de6',
                         color: 'white',
                         borderRadius: '5px',
                         cursor: 'pointer',
                         fontWeight: 'bold',
                         alignSelf: 'flex-end',
                         display: 'flex',
                         justifyContent: 'center',
                        }}
                 onClick={() => {
                   setRules(prev => {
                     const next = [...prev];
                     next[index] = {
                       ...editedRule,
                       ...getWhen(selectedCondition, values)
                     };
                     return next;
                   });
                   setVisible(false);
                 }}>
              Save
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default RuleModal;
